const MESSAGES = {
  expiredSession: 'Your session has expired. Please login again.',
};

export default MESSAGES;
